import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import {
  ROUTE_PATH_LIST,
  ROUTE_PATH_LIST_SETTINGS,
} from '../../../constants/route'
import { useLinkLikeClick } from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import Button, { BUTTON_HEIGHT_20 } from '../../Button'

import { PROFILE_LABELS_WIDGET_OPEN_SETTINGS_BUTTON_QA_NAME } from './ProfileLabelsWidgetOpenSettingsButton.constants'

import SettingsIcon from '../../../icons/settings.svg'

function ProfileLabelsWidgetOpenSettingsButton() {
  const { t } = useTranslation()

  const { handleClick } = useLinkLikeClick()

  function handleClickLabelSettings(event) {
    stopPropagation(event)

    handleClick({
      link: `/${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.labels}/`,
      outsideLink: true,
    })
  }

  return (
    <Button.Icon
      isGrey
      Icon={SettingsIcon}
      beforeIconProps={{ height: BUTTON_HEIGHT_20 }}
      qaName={PROFILE_LABELS_WIDGET_OPEN_SETTINGS_BUTTON_QA_NAME}
      tooltip={t('RequestProfile.LabelsWidgetOpenSettingsTooltipKey')}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
      onClick={handleClickLabelSettings}
    />
  )
}

export default ProfileLabelsWidgetOpenSettingsButton
